// How an audit entry reads, shared by Home and Activity.

import type { ActivityEntry } from '../../services/src/shared/api-types.ts';
import { person } from './format.ts';

export function headline(e: ActivityEntry): string {
  const who = person(e.actor);
  switch (e.action) {
    case 'approved': return `Approved by ${who}`;
    case 'rejected': return `Rejected by ${who}`;
    case 'posted': return 'Posted to Xero';
    case 'updated': return 'Updated in Xero';
    case 'voided': return 'Voided in Xero';
    case 'post_failed': return 'Xero refused';
    case 'plaid_linked': return `Bank connected by ${who}`;
    case 'plaid_link_started': return `Bank link started by ${who}`;
    case 'plaid_reconnected': return `Bank reconnected by ${who}`;
    case 'plaid_disconnected': return `Bank disconnected by ${who}`;
    case 'plaid_accounts_changed': return `Shared accounts changed by ${who}`;
    case 'plaid_new_accounts': return 'New account available';
    case 'plaid_purged': return `Test bank data deleted by ${who}`;
    case 'statement_set': return `Statement days set by ${who}`;
    case 'card_linked': return `Replaced card linked by ${who}`;
    case 'card_unlinked': return `Replaced card unlinked by ${who}`;
    case 'card_link_dismissed': return `Card suggestion dismissed by ${who}`;
    case 'sync': return 'Sync';
    default: return String(e.action);
  }
}

/** Subject and detail, with a reviewer's note in quotes. */
export function body(e: ActivityEntry): string {
  const detail = e.detail.replace(/(^|· )Note: (.*)$/, (_, lead: string, note: string) => `${lead}“${note}”`);
  return [e.subject, detail].filter(Boolean).join(' · ');
}

export const isFailure = (e: ActivityEntry) => e.action === 'post_failed';
